import { render, staticRenderFns } from "./FooterEmbed.vue?vue&type=template&id=3d20db0f&"
import script from "./FooterEmbed.vue?vue&type=script&lang=js&"
export * from "./FooterEmbed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports